import { useNavigate } from "react-router-dom";

export default function BlogPage() {
  const navigate = useNavigate();

  return (
    <>
      {/* Page Banner */}
      <div className="page-banner" style={{ background: "linear-gradient(135deg, rgb(26, 58, 26) 0%, rgb(45, 90, 27) 100%)" }}>
        <div>
          <h1>Blog</h1>
          <p>
            We believe great food should nourish you. Our story starts with
            ancient grains and ends on your plate.
          </p>
        </div>
      </div>

      {/* Blog Section */}
      <section className="blog-section">
        <div className="blog-container">

          <h1>Are Millet Momos Healthy?</h1>

          <p>
            Millet momos are one of the healthiest street foods in Hyderabad.
            Unlike traditional momos made with maida, millet momos are made using
            natural grains like ragi, jowar, and bajra.
          </p>

          <div className="blog-highlight">
            ✅ Millet momos = No maida + High nutrition + Better digestion
          </div>

          <h2>Why Millet Momos Are Healthy</h2>

          <ul>
            <li>High in fiber for better digestion</li>
            <li>Rich in plant-based protein</li>
            <li>Low glycemic index</li>
            <li>No refined flour (maida)</li>
          </ul>

          <h2>Millet Momos vs Regular Momos</h2>

          <p>
            Regular momos are made using refined flour (maida), which lacks
            nutrients. Millet momos provide essential vitamins, minerals, and
            sustained energy.
          </p>

          <h2>Where to Find Healthy Momos in Hyderabad?</h2>

          <p>
            Millet Momos brings you delicious and healthy momos made with 100%
            natural millets.
          </p>

          {/* React Navigation instead of href */}
          <button
            className="btn-primary"
            onClick={() => navigate("/menu")}
          >
            Explore Menu
          </button>

        </div>
      </section>
    </>
  );
}